import { observer } from 'mobx-react-lite'
import { Button, Divider, Icon, Typography, Box } from 'shared/ui'
import { useCopyToClipboard } from 'shared/hooks/useCopyToClipboard'
import { uiStore } from 'shared/store/uiStore'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { LINK_REVIEWS_GUIDE } from 'shared/constants/links'
import { ConversationRoutes } from 'pages/conversations'
import { BroadcastsRoutes } from 'pages/broadcasts'
import { ChatbotRoutes } from 'pages/chatbot'
import styles from './styles.module.scss'

type IReviewLandingUrlModalProps = {
  shortUrl: string
  modalId: string
}

export const ReviewLandingUrlModal = observer(
  ({ shortUrl, modalId }: IReviewLandingUrlModalProps) => {
    const { onCopy, copied } = useCopyToClipboard(shortUrl, { timeout: 6000 })
    const navigateHandler = (path: string) => {
      modalStore.closeModal(modalId)
      uiStore.changeRouteViaVue({ path })
    }

    return (
      <div className={styles.wrap}>
        <Box marginBottom={'16px'}>
          <Icon icon={'check2'} fontSize={32} color={'var(--green-60)'} />
        </Box>
        <Box marginBottom={'16px'}>
          <Typography variant={'heading-lg'} ariaLabel={'ReviewModalTitle'}>
            Review page created
          </Typography>
        </Box>
        <Box paddingX={'40px'} width={'100%'}>
          <div className={styles.urlWrap}>
            <Typography
              ariaLabel={'ReviewModalUrl'}
              variant={'body-md-regular'}
              className={styles.url}
              ellipsis
            >
              {shortUrl}
            </Typography>
            <Button
              tag={'button'}
              size={'small'}
              typeBtn={'contained'}
              contained={'primary'}
              icon={'copy'}
              text={copied ? 'Copied' : 'Copy'}
              onClick={onCopy}
            />
          </div>
        </Box>
        <Divider sx={{ marginY: '32px', width: '100%' }} />
        <Box maxWidth={'288px'} textAlign={'center'} marginBottom={'24px'}>
          <Typography variant={'body-rg-regular'} ariaLabel={'ReviewModalDesc'} color={'tertiary'}>
            Share this link with your contacts across any channel.{' '}
            <Typography
              tag={'a'}
              variant={'body-rg-medium'}
              color={'var(--content-brand-primary)'}
              ariaLabel={'LinkReviewsGuide'}
              className={styles.link}
              onClick={() => {
                window.open(LINK_REVIEWS_GUIDE, '_blank', 'noopener noreferrer')
              }}
            >
              Learn more
            </Typography>
          </Typography>
        </Box>
        <Box display={'flex'} justifyContent={'space-around'} gap={'8px'} paddingBottom={'16px'}>
          <Button
            contained={'secondary'}
            icon={'conversation'}
            text={'Conversations'}
            onClick={() => navigateHandler(`/${ConversationRoutes.root}`)}
          />
          <Button
            contained={'secondary'}
            icon={'broadcasts'}
            text={'Broadcasts'}
            onClick={() => navigateHandler(`/${BroadcastsRoutes.root}`)}
          />
          <Button
            contained={'secondary'}
            icon={'stars'}
            text={'AI Agents'}
            onClick={() => navigateHandler(`/${ChatbotRoutes.root}`)}
          />
        </Box>
      </div>
    )
  }
)
